export default class FreightMatchingSerializer {
  static serialize(data) {
    const payload = {
      ...data
    };

    const customProperties = [];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      carrierId: data.carrierId,
      carrierName: data.carrierName,
      carrierPhoneNumber: data.carrierPhoneNumber,
      commodity: data.commodity,
      customerId: data.customerId,
      customerName: data.customerName,
      destinationCity: data.destinationCity,
      destinationSchedArriveEarly: data.destinationSchedArriveEarly,
      destinationSchedArriveLate: data.destinationSchedArriveLate,
      destinationState: data.destinationState,
      matchType: data.matchType,
      maxPay: data.maxPay,
      milesFromDestination: data.milesFromDestination,
      milesFromOrigin: data.milesFromOrigin,
      mode: data.mode,
      orderId: data.orderId,
      orderWeight: data.orderWeight,
      originCity: data.originCity,
      originSchedArriveEarly: data.originSchedArriveEarly,
      originSchedArriveLate: data.originSchedArriveLate,
      originState: data.originState,
      targetPay: data.targetPay
    };
  }
}